import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class RegistrationValidator {

    login = [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(255),
        Validators.email
    ];

    password = [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(255),
        // Validators.pattern('^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])([0-9A-Za-z])+$')
    ];

    confirm_password = [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(255),
        // Validators.pattern('^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])([0-9A-Za-z])+$')
    ];

    second_name = [
        Validators.required,
        Validators.maxLength(255)
    ];

    first_name = [
        Validators.required,
        Validators.maxLength(255)
    ];

    last_name = [
        Validators.maxLength(255)
    ];

    // Error messages
    errorMessages = {
        login: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '5' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            },
            {
                type: 'email', 
                message: 'MESSAGES.EMAIL_FORMAT',
                options: null
            }
        ],
        password: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '8' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            },
            {
                type: 'pattern', 
                message: 'MESSAGES.PASSWORD_PATTERN',
                options: null
            }
        ],
        confirm_password: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '8' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            },
            {
                type: 'pattern', 
                message: 'MESSAGES.PASSWORD_PATTERN',
                options: null
            },
            {
                type: 'mustMatch', 
                message: 'MESSAGES.PASWORD_CONFIRMATION',
                options: null
            }
        ],
        second_name: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            }
        ],
        first_name: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            }
        ],
        last_name: [
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            }
        ]
    }
}